import { render, staticRenderFns } from "./BetriebsergebnisVergleich.vue?vue&type=template&id=c0ca410a&"
import script from "./BetriebsergebnisVergleich.vue?vue&type=script&lang=ts&"
export * from "./BetriebsergebnisVergleich.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports